export default __webpack_public_path__ + "static/media/android-download.cb94778a.PNG";